// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginForm_wrapper__v90fz {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #F8F6F1;
  padding: 32px 79px;
  border-radius: 32px;
  height: calc(100vh - 128px);
}
@media (max-width: 1024px) {
  .LoginForm_wrapper__v90fz {
    padding: 44px 16px;
    height: calc(100vh - 120px);
  }
}

.LoginForm_textWrapper__67fvY {
  font-weight: 700;
  font-size: 24px;
  margin-right: 24px;
}
@media (max-width: 1024px) {
  .LoginForm_textWrapper__67fvY {
    flex-direction: column;
  }
}

.LoginForm_iconTextWrapper__RiFlR {
  display: flex;
  margin-bottom: auto;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  color: #272E35;
}

.LoginForm_icon__i\\+0e7 {
  margin-right: 10px;
}

.LoginForm_formContainer__oRC7t {
  background-color: #FFFFFF;
  padding: 40px;
  border-radius: 32px;
  max-width: 304px;
}
@media (max-width: 1024px) {
  .LoginForm_formContainer__oRC7t {
    padding: 16px;
  }
}

.LoginForm_title__cvnUl {
  font-size: 24px;
  margin-bottom: 24px;
}
@media (max-width: 1024px) {
  .LoginForm_title__cvnUl {
    font-size: 18px;
  }
}

.LoginForm_loginButtonContainer__swkAY {
  margin-top: 16px;
  margin-bottom: 8px;
}

.LoginForm_mediaButtons__FIJya {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 40px;
}
@media (max-width: 1024px) {
  .LoginForm_mediaButtons__FIJya {
    margin-bottom: 24px;
  }
}

.LoginForm_textField__4Mpz2 {
  margin-top: 8px;
  width: 304px;
  border-radius: 8px;
  border: 1px solid #555F6D;
  height: 40px;
  padding: 0 7px;
  box-sizing: border-box;
}
@media (max-width: 1024px) {
  .LoginForm_textField__4Mpz2 {
    width: 280px;
  }
}

.LoginForm_separator__bLKM9 {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
@media (max-width: 1024px) {
  .LoginForm_separator__bLKM9 {
    margin-bottom: 24px;
  }
}

.LoginForm_line__H61w- {
  flex-grow: 1;
  height: 1px;
  background-color: #DEE3E7;
}

.LoginForm_lineL__VzcMC {
  margin-left: -40px;
}
@media (max-width: 1024px) {
  .LoginForm_lineL__VzcMC {
    margin-left: -16px;
  }
}

.LoginForm_lineP__ohJRj {
  margin-right: -40px;
}
@media (max-width: 1024px) {
  .LoginForm_lineP__ohJRj {
    margin-right: -16px;
  }
}

.LoginForm_separatorText__zfDYx {
  font-size: 14px;
  color: #555F6D;
  margin: 0 8px;
}

.LoginForm_footerContainer__WkOTb {
  display: flex;
  flex-direction: row;
  margin-top: auto;
  align-items: center;
}
@media (max-width: 1024px) {
  .LoginForm_footerContainer__WkOTb {
    margin-top: auto;
    flex-direction: column;
  }
}

.LoginForm_footerText__v5Ate {
  font-size: 14px;
  color: #555F6D;
}
@media (max-width: 1024px) {
  .LoginForm_footerText__v5Ate {
    order: 2;
    margin-top: 16px;
    margin-left: 0;
  }
}

.LoginForm_footerText2__Z5VbM {
  margin-left: 24px;
  font-size: 16px;
}
@media (max-width: 1024px) {
  .LoginForm_footerText2__Z5VbM {
    order: 1;
    margin-left: 0;
  }
}

.LoginForm_privatePolContainer__byy9n {
  color: #272E35;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginForm/LoginForm.module.scss","webpack://./src/styles/colors.scss","webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBCDO;EDEP,kBAAA;EACA,mBAAA;EACA,2BAAA;AAFJ;AERQ;EFCR;IAYQ,kBAAA;IACA,2BAAA;EADN;AACF;;AAIA;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;AADJ;AEpBQ;EFkBR;IAMQ,sBAAA;EAAN;AACF;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cClCM;ADkCV;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,yBC5CI;ED6CJ,aAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AE7CQ;EFyCR;IAOQ,aAAA;EACN;AACF;;AAEA;EACI,eAAA;EACA,mBAAA;AACJ;AEvDQ;EFoDR;IAKQ,eAAA;EAEN;AACF;;AACA;EACI,gBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAEJ;AExEQ;EFkER;IAOQ,mBAAA;EAGN;AACF;;AAAA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAGJ;AEvFQ;EF6ER;IAUQ,YAAA;EAIN;AACF;;AADA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAIJ;AElGQ;EF2FR;IAMQ,mBAAA;EAKN;AACF;;AAFA;EACI,YAAA;EACA,WAAA;EACA,yBCtGI;AD2GR;;AAFA;EAEI,kBAAA;AAKJ;AElHQ;EF2GR;IAKQ,kBAAA;EAMN;AACF;;AAHA;EAEI,mBAAA;AAMJ;AE5HQ;EFoHR;IAKQ,mBAAA;EAON;AACF;;AAJA;EACI,eAAA;EACA,cC5HQ;ED6HR,aAAA;AAOJ;;AAJA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAOJ;AE9IQ;EFmIR;IAOQ,gBAAA;IACA,sBAAA;EAQN;AACF;;AALA;EACI,eAAA;EACA,cC9IQ;ADsJZ;AEzJQ;EF+IR;IAKQ,QAAA;IACA,gBAAA;IACA,cAAA;EASN;AACF;;AANA;EACI,iBAAA;EACA,eAAA;AASJ;AErKQ;EF0JR;IAKQ,QAAA;IACA,cAAA;EAUN;AACF;;AAPA;EACI,cCrKM;EDsKN,qBAAA;AAUJ","sourcesContent":["@use '../../styles/colors' as colors; \n@use '../../styles/responsive' as rwd; \n\n.wrapper {\n    display: flex;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background-color: colors.$emerald7;\n    padding: 32px 79px;\n    border-radius: 32px;\n    height: calc(100vh - 128px);\n\n    @include rwd.breakpoint(small) {\n        padding: 44px 16px;\n        height: calc(100vh - 120px);\n    }\n}\n\n.textWrapper {\n    font-weight: 700;\n    font-size: 24px;\n    margin-right: 24px;\n\n    @include rwd.breakpoint(small) {\n        flex-direction: column;\n    }\n}\n\n.iconTextWrapper {\n    display: flex;\n    margin-bottom: auto;\n    flex-direction: row;\n    align-items: center;\n    text-decoration: none;\n    color: colors.$primary;\n}\n\n.icon {\n    margin-right: 10px;\n}\n\n.formContainer {\n    background-color: colors.$white;\n    padding: 40px;\n    border-radius: 32px;\n    max-width: 304px;\n\n    @include rwd.breakpoint(small) {\n        padding: 16px;\n    }\n}\n\n.title {\n    font-size: 24px;\n    margin-bottom: 24px;\n\n    @include rwd.breakpoint(small) {\n        font-size: 18px;\n    }\n}\n\n.loginButtonContainer {\n    margin-top: 16px;\n    margin-bottom: 8px;\n}\n\n.mediaButtons {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 40px;\n\n    @include rwd.breakpoint(small) {\n        margin-bottom: 24px;\n    }\n}\n\n.textField {\n    margin-top: 8px;\n    width: 304px;\n    border-radius: 8px;\n    border: 1px solid colors.$secondary;\n    height: 40px;\n    padding: 0 7px;\n    box-sizing: border-box;\n\n    @include rwd.breakpoint(small) {\n        width: 280px;\n    }\n}\n\n.separator {\n    display: flex;\n    align-items: center;\n    margin-bottom: 40px;\n\n    @include rwd.breakpoint(small) {\n        margin-bottom: 24px;\n    }\n}\n  \n.line {\n    flex-grow: 1;\n    height: 1px;\n    background-color: colors.$grey4;\n}\n\n.lineL {\n    composes: line;\n    margin-left: -40px;\n\n    @include rwd.breakpoint(small) {\n        margin-left: -16px;\n    }\n}\n\n.lineP {\n    composes: line;\n    margin-right: -40px;\n\n    @include rwd.breakpoint(small) {\n        margin-right: -16px;\n    }\n}\n\n.separatorText {\n    font-size: 14px;\n    color: colors.$secondary;\n    margin: 0 8px;\n}\n\n.footerContainer {\n    display: flex;\n    flex-direction: row;\n    margin-top: auto;\n    align-items: center;\n\n    @include rwd.breakpoint(small) {\n        margin-top: auto;\n        flex-direction: column;\n    }\n}\n\n.footerText {\n    font-size: 14px;\n    color: colors.$secondary;\n\n    @include rwd.breakpoint(small) {\n        order: 2;\n        margin-top: 16px;\n        margin-left: 0;\n    }\n}\n\n.footerText2 {\n    margin-left: 24px;\n    font-size: 16px;\n\n    @include rwd.breakpoint(small) {\n        order: 1;\n        margin-left: 0;\n    }\n}\n\n.privatePolContainer {\n    color: colors.$primary;\n    text-decoration: none;\n}","$white: #FFFFFF;\n\n$primary: #272E35;\n\n$grey4: #DEE3E7;\n$secondary: #555F6D;\n$whitealfa: #9E9E9E;\n$emerald5: #F4EAD7;\n$emerald7: #F8F6F1;\n\n$green0: #0EB77A;\n$green4: #08200D;\n$green5: #E1F9F0;\n\n// APP\n$secondaryAPP: #D8F8E7;\n$primaryAPP: #1D7C4D;\n$primaryGreenAPP: #086E49;\n$action: #CFD6DD;\n$surface: #FCFCFD;\n$neutral: #F5F7F9;\n$raspberry: #FBD5E2;\n$greenAPP: #C6F1DA;\n$defaultAPP: #EAEDF0;","@mixin breakpoint($point) {\n    @if $point == small {\n        @media (max-width:  1024px) { @content; }\n    }\n    // @else if $point == medium {\n    //     @media (min-width:  769px) and (max-width: 1280px) { @content; }\n    // }\n    @else if $point == large {\n        @media (min-width:  1025px) { @content; }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `LoginForm_wrapper__v90fz`,
	"textWrapper": `LoginForm_textWrapper__67fvY`,
	"iconTextWrapper": `LoginForm_iconTextWrapper__RiFlR`,
	"icon": `LoginForm_icon__i+0e7`,
	"formContainer": `LoginForm_formContainer__oRC7t`,
	"title": `LoginForm_title__cvnUl`,
	"loginButtonContainer": `LoginForm_loginButtonContainer__swkAY`,
	"mediaButtons": `LoginForm_mediaButtons__FIJya`,
	"textField": `LoginForm_textField__4Mpz2`,
	"separator": `LoginForm_separator__bLKM9`,
	"line": `LoginForm_line__H61w-`,
	"lineL": `LoginForm_lineL__VzcMC LoginForm_line__H61w-`,
	"lineP": `LoginForm_lineP__ohJRj LoginForm_line__H61w-`,
	"separatorText": `LoginForm_separatorText__zfDYx`,
	"footerContainer": `LoginForm_footerContainer__WkOTb`,
	"footerText": `LoginForm_footerText__v5Ate`,
	"footerText2": `LoginForm_footerText2__Z5VbM`,
	"privatePolContainer": `LoginForm_privatePolContainer__byy9n`
};
export default ___CSS_LOADER_EXPORT___;
